var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('FormLoader'):_c('company-form',{attrs:{"showDeleteButton":true,"isSubmitting":_vm.isSubmitting},on:{"delete-company":_vm.deleteCompany,"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }